import React from "react";
import "./InfoTooltip.css"; 

const InfoTooltip = ({ text }) => (
  <span className="info-tooltip">
    ⓘ
    <span
      className="info-tooltip__text"
      dangerouslySetInnerHTML={{ __html: text }}
    />
  </span>
);

export default React.memo(InfoTooltip);
